// extracted by mini-css-extract-plugin
export default {"faqWrap":"Faq_faqWrap__dc0Ds"};